import { FC, PropsWithChildren, useContext } from "react";
import { useTranslation } from "react-i18next";

import { ConflictsNav, ExpandedAdornment } from "@ryde/controls";

import { BulkPreviewStepUploadConflictsContext } from "../../bulk-preview-step-upload-conflicts.context";

type IRejectedBookingUploadExpandedProps = PropsWithChildren;

export const RejectedBookingUploadExpanded: FC<
  IRejectedBookingUploadExpandedProps
> = ({ children }) => {
  const { t } = useTranslation();
  const { conflicts } = useContext(BulkPreviewStepUploadConflictsContext);

  return (
    <ExpandedAdornment
      NavControl={
        <ConflictsNav
          title={t(`booking.bulk.conflicts.${conflicts?.at(0)?.errorType}`)}
          conflictNumber={conflicts?.length ?? 0}
        />
      }
    >
      {children}
    </ExpandedAdornment>
  );
};
